import { SubscriptionPlan } from '@innovationdepartment/proxima-sdk-axios';
import { useToaster } from '@innovationdepartment/proxima-ui';
import { useBillingApi } from 'api';
import { useBrandStore } from 'stores';

const useBilling = () => {
  const { createShopifySubscription, deleteShopifySubscription, loading } = useBillingApi();
  const { brand } = useBrandStore();
  const { showToaster } = useToaster();

  const navigateToShopifyApprovalPage = async (planType: SubscriptionPlan) => {
    const confirmationUrl = await createShopifySubscription(brand.brandId, planType);

    if (!confirmationUrl) {
      showToaster({
        message: 'Error processing subscription. Please try again.',
        variant: 'error',
      });

      return;
    }

    window.open(confirmationUrl, '_self');
  };

  const deleteSubscription = async () => {
    await deleteShopifySubscription(brand.brandId);
  };

  return {
    navigateToShopifyApprovalPage,
    deleteSubscription,
    loading,
  };
};

export default useBilling;
